import React from "react";
import "./comparisonFeatures.css";

const ComparisonFeatures = ({ features, title, platform }) => {

    return (<div className="features-section--outer" id="comparison-features-section">
        <h4>{title}</h4>
        <div className="comparison-table table-striped">
            <table>
                <thead>
                    <tr>
                        <th className="comparison-topic">&nbsp;</th>
                        <th className="comparison-title">Realtor Real Estate</th>
                        <th className="comparison-title">{platform}</th>
                    </tr>
                </thead>
                <tbody>
                    {features.map((feature, index) => (
                        <tr key={index}>
                            <td className="comparison-topic">
                                {feature.name}
                            </td>
                            <td className="comparison-title">
                                {feature?.realtor ? feature?.realtor === "Yes" ? (<i className="fa fa-check" />) : feature?.realtor === "No" ? (<i className="fa fa-multiply" />) : (feature?.realtor) : (<i className="fa fa-check" />)}
                            </td>
                            <td className="comparison-title">
                                {feature.type === "Yes" ? (<i className="fa fa-check" />) : feature.type === "No" ? (<i className="fa fa-multiply" />) : (feature.type)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>);
};

export default ComparisonFeatures;
